import { CloudUploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Modal, Row, Spin, Typography } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import SummaryCountModal from "./SummaryCountModal";
import { getPortalDetailsByTypeAndId } from "../../../apis/reconciliationService";
import { errorMessage } from "../../../utils/notificationUtils";
import { get } from "http";

const { Text } = Typography;

interface TileData {
  name: string;
  recordsFetched: number;
  type: string;
  id: number;
}

interface Props {
  open: boolean;
  onClose: () => void;
  summaryData: any;
  tilesData: TileData[];
  isSummaryModalDataLoading: boolean;
}

const SummaryModal: React.FC<Props> = ({
  open,
  onClose,
  summaryData,
  tilesData,
  isSummaryModalDataLoading,
}) => {
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [selectedTile, setSelectedTile] = useState<any>(null);
  const [selectedTileIndex, setSelectedTileIndex] = useState<number | null>(
    null,
  );
  const [countModalData, setCountModalData] = useState<any>([]);
  const [countModalTotal, setCountModalTotal] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  const getPortalDetails = async (
    type: string,
    id: number,
    pageNumber: number = 1,
    pageSize: number = 50,
  ) => {
    try {
      setLoading(true);
      const page = pageNumber - 1;
      const size = pageSize;

      const res = await getPortalDetailsByTypeAndId(
        type,
        id,
        summaryData.hospitalId,
        summaryData.schemeId,
        page,
        size,
      );

      setCountModalData(res?.content || []);
      setCountModalTotal(res?.totalElements || 0);
      setLoading(false);
    } catch (err) {
      errorMessage("Failed to fetch detailed data. Please try again later.");
      setLoading(false);
      setCountModalData([]);
    }
  };

  const handleTileClick = async (tile: TileData, index: number) => {
    setSelectedTile(tile);
    setSelectedTileIndex(index);
    setOpenDetailModal(true);
    getPortalDetails(tile.type, tile.id);
  };

  const resetTileSelection = () => {
    setSelectedTile(null);
    setSelectedTileIndex(null);
  };

  useEffect(() => {
    if (!open) {
      resetTileSelection();
      setCountModalData([]);
      setCountModalTotal(0);
    }
  }, [open]);

  useEffect(() => {
    if (!openDetailModal) {
      setCountModalData([]);
    }
  }, [openDetailModal]);

  return (
    <Modal open={open} footer={null} onCancel={onClose} width={1000}>
      <Spin spinning={isSummaryModalDataLoading} tip="Loading summary...">
        <div style={{ textAlign: "center", padding: 20 }}>
          <CloudUploadOutlined style={{ fontSize: 50, color: "#1677ff" }} />

          <h2 style={{ marginTop: 10, color: "#1677ff" }}>
            Data Processed Successfully
          </h2>

          <Row
            justify="space-around"
            style={{
              marginTop: 20,
              background: "#f4f6f8",
              padding: 20,
              borderRadius: 10,
            }}
          >
            <Col>
              <Text>Total Records</Text>
              <h3>{summaryData?.processedRecords ?? "-"}</h3>
            </Col>

            <Col>
              <Text>Processed Successfully</Text>
              <h3 style={{ color: "#1677ff" }}>
                {summaryData?.processedRecords ?? "-"}
              </h3>
            </Col>

            {/* <Col>
            <Text>Failed during processing</Text>
            <h3 style={{ color: "#ff4d4f" }}>-</h3>
          </Col> */}
          </Row>

          {/* Tiles Section */}
          <Row gutter={[20, 20]} style={{ marginTop: 30 }}>
            {tilesData?.map((tile: TileData, index: number) => (
              <Col key={index} xs={24} sm={12} md={8} lg={6} xl={6}>
                <Card
                  hoverable
                  onClick={() => handleTileClick(tile, index)}
                  bodyStyle={{ padding: 16 }}
                  style={{
                    borderRadius: 12,
                    height: 100,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    border:
                      selectedTileIndex === index
                        ? "1.5px solid #1677ff"
                        : "1px solid #e5e7eb",
                    boxShadow:
                      selectedTileIndex === index
                        ? "0 6px 18px rgba(22,119,255,0.15)"
                        : "0 2px 6px rgba(0,0,0,0.05)",
                    position: "relative",
                    transition: "all 0.25s ease",
                    background: "#fff",
                  }}
                >
                  {/* Accent bar */}
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 0,
                      bottom: 0,
                      width: 4,
                      borderRadius: "12px 0 0 12px",
                      background:
                        selectedTileIndex === index ? "#1677ff" : "#d9d9d9",
                    }}
                  />

                  {/* Title */}
                  <Text
                    style={{
                      fontSize: 13,
                      color: "#6b7280",
                      fontWeight: 500,
                    }}
                  >
                    {tile.name}
                  </Text>

                  {/* Count */}
                  <div
                    style={{
                      fontSize: 26,
                      fontWeight: 600,
                      color: "#111827",
                    }}
                  >
                    {tile.recordsFetched}
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Spin>

      <SummaryCountModal
        open={openDetailModal}
        onClose={() => setOpenDetailModal(false)}
        title={selectedTile?.name}
        scheme={summaryData?.scheme}
        countModalData={countModalData}
        isLoading={loading}
        selectedTile={selectedTile}
        countModalTotal={countModalTotal}
        getPortalDetails={getPortalDetails}
      />
    </Modal>
  );
};

export default SummaryModal;
